<template>
  <mw-dialog ref="dialog" title="催办" :appendToBody="false" size='small_small' :footerButton="footerButton"
  :before-close="handleClose">
     <div class="mw-toolbar__body,mw-margin-top-10" style="margin-top:20px;">
        <template>
          <el-form  label-width="130px" ref="urgeForm" :model="form">
            <el-row>
              <el-col :span="24">
                <el-form-item label="题名">
                  <el-input v-model="form.businessName" style="width: 70%" readonly></el-input>
                </el-form-item>
              </el-col>

              <el-col :span="24">
                <el-form-item label="催办信息" >
                  <el-input v-model="form.message" type="textarea" style="width: 70%"></el-input>
                </el-form-item>
              </el-col>

              <el-col :span="24">
                <el-form-item label="通知人" >
                  <el-checkbox-group v-model="notifierId" @change="handleChange">

                    <template v-for="list in params.data">

                     <el-col :span="9" v-for="item in list.transactors" :key="item.id">
                      <el-checkbox
                      :label="item.id" :key="item.name" >{{item.name}}</el-checkbox>
                    </el-col>

                    </template>

                  </el-checkbox-group>


                </el-form-item>
              </el-col>

              <el-col :span="24">
                <el-form-item label="通知方式" >
                  <template>
                    <el-checkbox-group v-model="noticeWay" @change="handleNoticeChange">
                      <!-- <el-checkbox v-for="item in params.remindMode"
                      label="item" :key="item"  >{{item}}</el-checkbox> -->
                      <el-checkbox label="1" :key="1">发送短信</el-checkbox>
                      <el-checkbox label="2" :key="2">即时消息</el-checkbox>
                    </el-checkbox-group>
                  </template>
                </el-form-item>
              </el-col>

            </el-row>
          </el-form>

        </template>
      </div>

  </mw-dialog>
</template>
<script>
export default {
  props: {
    params: {
      type: Object
    }
  },
  data() {
    return {
      footerButton: [
        {
          label: "确定",
          func: this.saveSure
        }
      ],
      noticeWay: [],
      notifierId: [],
      notifier: [],
      taskId: [],
      form: {
        urgeTasks: []
      }
    };
  },
  created() {
    this.initData();
  },
  mounted() {
    let me = this;
    setTimeout(() => {
      this.show();
      if (this.params.data && this.params.data.length>0) {
        //console.log(this.params);
        this.params.data.forEach((it)=>{
          if (it.transactors && it.transactors.length>0) this.notifierId.concat(it.transactors);
        })
      }
    }, 200);
  },
  watch: {
    params(val) {
      this.form = { urgeTasks: [] };
      this.noticeWay = [];
      this.notifierId = [];
      this.notifier = [];
      this.taskId = [];
      this.mwRef("urgeForm").resetFields();
      this.initData();
    }
  },
  methods: {
    initData() {
      this.form.businessName = this.params.businessName;
    },
    saveSure() {
      if (!this.form.message) {
        this.form.message = $lang("请及时处理。");
      }
      if (this.notifierId.length == 0) {
        PF.message($lang("请选择通知人。"));
        return;
      }
      this.form.urgeTasks = [];
      this.taskId.forEach((t, index) => {
        this.form.urgeTasks.push({
          taskId: this.taskId[index],
          urgedUserId: this.notifierId[index],
          urgedUser: this.notifier[index]
        });
      });
      this.params.func(this.form);
      this.mwRef("urgeForm").resetFields();
      this.form = { urgeTasks: [] };
      this.noticeWay = [];
      this.notifierId = [];
      this.notifier = [];
      this.taskId = [];
      this.mwRef("dialog").hide();
    },
    handleChange(data) {
      // console.log(data)
      let notifier = [];
      let taskId = [];

      data.forEach(t => {
        this.params.data.forEach(d => {
          d.transactors.forEach(r => {
            if (t === r.id) {
              notifier.push(r.name);
              taskId.push(d.taskId);
              return;
            }
          });
        });
      });

      this.notifier = notifier;
      this.taskId = taskId;
    },
    handleNoticeChange(data) {
      this.form.remindMode = data.join();
    },
    handleClose() {
      this.mwRef("urgeForm").resetFields();
      this.form = { urgeTasks: [] };
      this.noticeWay = [];
      this.notifierId = [];
      this.notifier = [];
      this.taskId = [];
      this.mwRef("dialog").hide();
    },
    show() {
      this.mwRef("dialog").show();
    }
  }
};
</script>





// WEBPACK FOOTER //
// src/modules/index/components/public-dialog/urge-process.vue